import axios from 'axios';
import apiClient from './apiClient';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';

const publicClient = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

const followUpService = {
  // Admin
  getAll: async (params = {}) => {
    const response = await apiClient.get('/follow-ups', { params });
    return response.data;
  },
  getStats: async () => {
    const response = await apiClient.get('/follow-ups/stats');
    return response.data;
  },
  trigger: async (workOrderId) => {
    const response = await apiClient.post('/follow-ups/trigger', { workOrder: workOrderId });
    return response.data;
  },
  markSent: async (id, channel = 'whatsapp') => {
    const response = await apiClient.patch(`/follow-ups/${id}/sent`, { channel });
    return response.data;
  },
  dismiss: async (id) => {
    const response = await apiClient.patch(`/follow-ups/${id}/dismiss`);
    return response.data;
  },
  restore: async (id) => {
    const response = await apiClient.patch(`/follow-ups/${id}/restore`);
    return response.data;
  },
  remove: async (id) => {
    const response = await apiClient.delete(`/follow-ups/${id}`);
    return response.data;
  },
  // Public
  getByToken: async (token) => {
    const response = await publicClient.get(`/public/follow-ups/${token}`);
    return response.data;
  },
  submitResponse: async (token, data) => {
    const response = await publicClient.post(`/public/follow-ups/${token}`, data);
    return response.data;
  },
};

export default followUpService;
